import { useEffect } from "react";
import { Rotate } from "@embedpdf/plugin-rotate/react";
import { Viewport } from "@embedpdf/plugin-viewport/react";
import { Scroller } from "@embedpdf/plugin-scroll/react";
import { RenderLayer } from "@embedpdf/plugin-render/react";
import { ZoomGestureWrapper } from "@embedpdf/plugin-zoom/react";
import {
  PagePointerProvider,
  GlobalPointerProvider,
} from "@embedpdf/plugin-interaction-manager/react";
import { TilingLayer } from "@embedpdf/plugin-tiling/react";

const RenderPDF = ({ activeDocumentId, setShowLoader, viewerRef }) => {
  // track if the img element to display pdf finished rendering
  useEffect(() => {
    if (!activeDocumentId) return;
    if (!viewerRef.current) return;

    // MutationObserver: a browser API that watches for changes in the DOM
    const observer = new MutationObserver(() => {
      const imgElement = viewerRef?.current?.querySelector("img");

      if (imgElement && imgElement.width > 0 && imgElement.height > 0) {
        setShowLoader(false);
        observer.disconnect();
      }
    });

    observer.observe(viewerRef.current, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, [activeDocumentId]);

  return (
    <GlobalPointerProvider documentId={activeDocumentId}>
      <Viewport
        documentId={activeDocumentId}
        style={{ height: "90%", width: "100%" }}
      >
        <ZoomGestureWrapper
          documentId={activeDocumentId}
          enablePinch={true}
          enableWheel={false}
        >
          <Scroller
            documentId={activeDocumentId}
            renderPage={({ pageIndex }) => (
              <PagePointerProvider
                documentId={activeDocumentId}
                pageIndex={pageIndex}
              >
                <Rotate
                  documentId={activeDocumentId}
                  pageIndex={pageIndex}
                >
                  <RenderLayer
                    documentId={activeDocumentId}
                    pageIndex={pageIndex}
                  />
                  <TilingLayer
                    documentId={activeDocumentId}
                    pageIndex={pageIndex}
                    style={{ pointerEvents: "none" }}
                  />
                </Rotate>
              </PagePointerProvider>
            )}
          />
        </ZoomGestureWrapper>
      </Viewport>
    </GlobalPointerProvider>
  );
};

export default RenderPDF;